module.exports = __webpack_public_path__ + "media/images/athletes/2616-2b5810aae4311d9f3593b2801d664ea0.png";